/**
 * Resolves the asset behind a list entry.
 *
 * `assetsById` holds what the list's own endpoint returned for every entry,
 * so it wins: the grid only ever has the page it is currently showing, and
 * preferring it made an entry blink back to "unavailable" the moment paging,
 * a folder change or an archive filter dropped that asset. The grid is kept
 * only as a stand-in for an asset just dropped in, before its fetch lands.
 *
 * Shared by the list strip and the overlay preview so the two can never
 * disagree about which asset an entry points at.
 *
 * @input {assetId: 'a1', resolveAssetById: (id) => null, assetsById: {a1: {_id: 'a1', url: 'https://…'}}}
 * @output {_id: 'a1', url: 'https://…'}
 */
export function resolveEntryAsset({ assetId, resolveAssetById, assetsById }) {
  const fetchedAsset = assetsById?.[assetId];
  if (fetchedAsset && fetchedAsset.url) return fetchedAsset;

  const assetFromGrid = resolveAssetById?.(assetId);
  if (assetFromGrid) return assetFromGrid;

  return null;
}
